export default __webpack_public_path__ + "static/media/goshen3.ed626558.jpg";